export type NavigationLink = {
  label: string;
  href: string;
  group?: string;
  subgroup?: string;
  image?: string;
  current?: boolean;
};
export type NavigationEntry =
  | { kind: "link"; link: NavigationLink }
  | { kind: "group"; label: string; links: NavigationLink[] };

/** Group only links the server has already allowed; each group keeps its first position. */
export function groupNavigation(items: readonly NavigationLink[]): NavigationEntry[] {
  const entries: NavigationEntry[] = [];
  const groups = new Map<string, Extract<NavigationEntry, { kind: "group" }>>();
  for (const item of items) {
    if (!item.group) entries.push({ kind: "link", link: item });
    else {
      let group = groups.get(item.group);
      if (!group) {
        group = { kind: "group", label: item.group, links: [] };
        groups.set(item.group, group);
        entries.push(group);
      }
      group.links.push(item);
    }
  }
  return entries;
}

/** A second disclosure level, after the server has filtered each destination. */
export function groupNavigationChildren(items: readonly NavigationLink[]): NavigationEntry[] {
  return groupNavigation(
    items.map(({ group: _group, subgroup, ...item }) => ({ ...item, group: subgroup })),
  );
}
